import { defineCustomElement } from "vue";
import App from "@/App.vue";

const bus = useEventBus<string>("main");

const { storeAssistantId, storeSettingsId, assistantId } = useGlobalConfig();

// Save assistant and settings ID
storeAssistantId();
storeSettingsId();

// Abort execution when not assistant id is present
if (!assistantId.value) {
  throw new Error(
    "Please provide an Assistant ID as an 'aid' query string parameter.",
  );
}

// Create new custom element
const MyVueElement = defineCustomElement({
  render: () => h(App),
  setup() {
    const app = createApp({});

    const pinia = createPinia();

    app.use(sentry);

    app.use(firebase);

    app.use(axios);

    app.use(pinia);

    const instance = getCurrentInstance();

    // Copy the app context over to the freshly created app
    if (instance) {
      Object.assign(instance.appContext, app._context);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      Object.assign((instance as any).provides, app._context.provides);
    }
  },
});

// Register the custom element. After registration, all `<wijsneus-widget>` tags on the page will be upgraded.
customElements.define("wijsneus-widget", MyVueElement);

// Create <wijsneus-widget> element in the DOM with the necesary props injected
window.addEventListener("DOMContentLoaded", function () {
  document.body.appendChild(
    new MyVueElement({
      // "assistant-id": assistantId.value,
    }),
  );
});

// Expose public methods
window.wijsneus = {
  open: () => bus.emit("panel:open"),
  minimize: () => bus.emit("panel:minimize"),
  expand: () => bus.emit("panel:expand"),
  collapse: () => bus.emit("panel:collapse"),
  close: () => bus.emit("panel:force-close"),
};
